/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RemoveInputs */

const vi_common_remove = /** @type {(inputs: Common_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa`)
};

/**

* @param {Common_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_remove = /** @type {((inputs?: Common_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_remove(inputs)
});